const BASE_URL = "https://codecrafters.getkosh.com/backend/test4/lsp-suite";
const username = "test_empower";
const password = "empower101";

let jwtToken = "";

export const getToken = async () => {
    const res = await fetch(`${BASE_URL}/get-token/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
    });
    const data = await res.json();
    jwtToken = data.token;
    return data;
};

const headers = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwtToken}`,
});

export const createLoan = async (loanData) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/create-loan/`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(loanData),
    });
    return res.json();
};

export const getLoanStatus = async (loanId) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/loan-status/`, {
        method: "GET",
        headers: headers(),
    });
    return res.json();
};

export const getRepaymentSchedule = async (loanId, startDate) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/get-repayment-schedule/?start_date=${startDate}`, {
        method: "GET",
        headers: headers(),
    });
    return res.json();
};

export const initiateNach = async (loanId) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/initiate-nach/`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify({ account_type: "savings", is_setu: true }),
    });
    return res.json();
};

export const createAgreement = async (loanId) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/create-agreement/`, {
        method: "POST",
        headers: headers(),
    });
    return res.json();
};

export const getLoanDetails = async (loanId) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/loan-details/`, {
        method: "GET",
        headers: headers(),
    });
    return res.json();
};

export const uploadDocument = async (loanId, file, docType) => {
    const formData = new FormData();
    formData.append("doc_type", docType);
    formData.append("file", file);

    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/upload-documents/`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        },
        body: formData,
    });

    return res.json();
};

export const retrieveDocuments = async (loanId) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/retrieve-documents/`, {
        method: "GET",
        headers: headers(),
    });
    return res.json();
};

export const viewAgreement = async (loanId) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/view-agreement/`, {
        method: "GET",
        headers: headers(),
    });
    return res.text();
};

export const initiateUPIPayment = async (loanId, amount = 1) => {
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/initiate-upi-payment/`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify({ amount }),
    });
    return res.json();
};

export const getPayments = async (loanId, paymentId = null) => {
    const query = paymentId ? `?payment_id=${paymentId}` : "";
    const res = await fetch(`${BASE_URL}/LSPLoan/${loanId}/get-payment/${query}`, {
        method: "GET",
        headers: headers(),
    });
    return res.json();
};
